<div class="release-history-conatiner">
  <div class="release-history-header">
    <div class="release-header-top">
      <div class="release-header-icon">
        <img class="release-image" src="assets/images/logo.svg" alt="logo" />
        <span class="header-text">Release History</span>
      </div>
      <div class="margin-adjust">
        <button class="header-text" (click)=" $event.preventDefault(); $event.stopPropagation();openHelpInfo() ">Help Doc</button>
        <button class="header-text" (click)="openCiraPlatform()">Cira Platform</button>
      </div>
    </div>
    <div class="release-header-bottom">
      <h4><img class="release-image" alt="logo" src="assets/images/logo.svg"><b>  CIRA Release History</b></h4>
      <p>An appendix of hosted documentation for nearly every release of Cira.</p>
    </div>
  </div>

  <div class="release-history-body">
    <div>
      <div class="release-history-checks">
        <div class="d-flex">
          <button class="btn-sort me-2" (click)="onClickSort()">{{ sortOrder | uppercase}}</button>
          <div class="position-relative">
            <input class="search-input" type="text" [(ngModel)]="searchKey" 
              placeholder="Search by Release name and Release highlights" name="search" (ngModelChange)="searchReleaseData()">
            <i *ngIf="!searchKey" class="icon-search search-icon"></i>
            <span *ngIf="searchKey" class="icon-cira search-icon" (click)="searchKey = ''; searchReleaseData()"></span>
          </div>
        </div>
        <p><b>{{numberOfRelease}}</b></p>
      </div>
      <div  id="myTableBody">
        <table class="table details-table">
          <thead>
            <tr>
              <th scope="col">Release name</th>
              <th scope="col">Release Date</th>
              <th scope="col">Release Highlights</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of tableData">
              <td>
                <a class="release-link" (click)="open(helpGuide, item)">{{item.release_name}}</a>
                <button *ngIf="item.release_date == latestDate" class="btn-latest"> Latest</button> 
              </td>
             <td>{{formatDate(item.release_date)}}</td>
              <td>{{item.release_highlights}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<ng-template #helpGuide let-c="close" let-d="dismiss">
  <div class="tour-start-modal">
      <div class="modal-header">
          <h4 class="modal-title">Cira Help Docs</h4>
          <div class="right-cntrl-icons">
              <button class="help-doc-minimize"  ngbTooltip="Resize window" placement="bottom" (click)="maximizeHelpDoc()"><span class="icon iconB-min-max-window"></span></button>
              <button type="button" class="close" ngbTooltip="Close" placement="bottom" aria-label="Close" (click)="d('Cross click')">
                  <i class="icon icon-cira"></i>
          </button>
          </div>
      </div>

      <div class="modal-body">
          <div class="iframe-wrap">
              <iframe [src]="docUrl" height="500" width="1000" title="description"></iframe>
          </div>
      </div>
  </div>
</ng-template>